module.exports = __webpack_public_path__ + "5ad8b07e0709767cb40e70b00d388520.pdf";